import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { EffectFade, Controller } from 'swiper';

import { ContentSliderContainer } from './slider.styles';

export default function ContentSlider({ slides, currentSlide, options }) {
  const slider = useRef(null);
  const [sliderVisibility, setSliderVisibility] = useState(false);
  const { speed } = options;

  useEffect(() => {
    if (slider.current) {
      slider.current?.swiper?.slideTo(currentSlide, speed);
    }
  }, [currentSlide, speed]);

  return (
    <ContentSliderContainer
      className={`content-slider${!sliderVisibility ? ' hidden' : ''}`}>
      <Swiper
        initialSlide={currentSlide}
        onSwiper={() => setSliderVisibility(true)}
        ref={slider}
        slidesPerView={1}
        modules={[Controller, EffectFade]}
        effect='fade'
        noSwiping='true'
        noSwipingClass='swiper-slide'
        fadeEffect={{
          crossFade: true,
        }}>
        {React.Children.map(slides, (slide) => (
          <SwiperSlide className='content-slide'>{slide}</SwiperSlide>
        ))}
      </Swiper>
    </ContentSliderContainer>
  );
}

ContentSlider.propTypes = {
  slides: PropTypes.node,
  currentSlide: PropTypes.number,
  options: PropTypes.shape({
    speed: PropTypes.number,
  }),
};

ContentSlider.defaultProps = {
  slides: [],
  currentSlide: 1,
  options: PropTypes.shape({
    speed: 500,
  }),
};
